// Kept in sync with the backend aggregate invariant (app/src/academy-context/shared/domain/constants/batch-price.ts)
export const MIN_BATCH_PRICE = 1;
export const MAX_BATCH_PRICE = 4000;
